import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/main';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

function bootstrap(): void {
  platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.error(err));
};


if (document.readyState === 'complete') {
  bootstrap();
} else {
  document.addEventListener('DOMContentLoaded', bootstrap);
}
